import React, {  useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getApiAction, getSiteId, postApiAction } from "../../Utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { setTableInfo } from "../../store/action";
import { BASE_URL } from '../../constants';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const bannerStyle = {
    backgroundImage: `url(${BASE_URL}/assets/images/login_Bg.png)`,
  };
  const bannerStyle2 = {
    backgroundImage: `url(${BASE_URL}/assets/images/login_Bg2.png)`,
  };

  const initialFormData = {
    reservation_id: ""
  };

  const [formData, setFormData] = useState(initialFormData);

  const [errors, setErrors] = useState({
    reservation_id: ""
  });

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const editQuery = params.get('edit');
  let tableInfoEdit = useSelector((state) => state.main.tableInfo)

  if (!tableInfoEdit.table_no) {
    tableInfoEdit = JSON.parse(localStorage.getItem('bookingData'));
  }

  useEffect(() => {
    if (editQuery == 'true') {
      setFormData(tableInfoEdit)
    } else {
      localStorage.removeItem('booking_reference_id');
      localStorage.removeItem('bookingData');
    }
    
  },[])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleClick = async (e) => {
    
    e.preventDefault();

    const newErrors = {};

    // Validate required fields
    if (!formData.reservation_id.trim()) {
      newErrors.reservation_id = "The seservation no. field is required.";
    }

    setErrors(newErrors);

    // If there are no errors, proceed with form submission logic
    if (Object.keys(newErrors).length === 0) {
       let resp = await postApiAction('auth/submit', formData,  0, dispatch);
      if (resp?.booking_reference_id) {
        dispatch(setTableInfo({}))
        localStorage.setItem("booking_reference_id", resp.booking_reference_id);
        var formDataString = JSON.stringify(resp.user);
        localStorage.setItem('bookingData', formDataString);
        formData['booking_reference_id'] = resp.booking_reference_id;
        dispatch(setTableInfo(formData))
        setFormData({
          'reservation_id': formData.reservation_id
        });
        navigate("/" + getSiteId() + "/welcome");
      } else if(resp?.response?.data?.errors){
        const _errors = resp?.response?.data?.errors;
        
        for (const [key, err] of Object.entries(_errors)) {
          //if (!errors.hasOwnProperty(key)) {
            newErrors[key] = _errors[key][0]
            setErrors(newErrors);
          //}
        }
      }
    }   
  }

  const isFormFilled = () => {
    return formData.reservation_id !== '';
  };


  const goSplashScreen = () => {
    window.location.reload();
  }

  return (
    <div>
      <div className="wrapper">
        <div className="bannerArea loginBanner" style={bannerStyle}>
          <div className="logo">
            <a href="#">
              <img src={`${BASE_URL}/assets/images/logo.png`} alt="" />
            </a>
          </div>
          <div className="container">
            <div className="loginForm" style={bannerStyle2}>
              <div className="loginContentBox">
                <h2>¡Hola!</h2>
                <p>Ingresa tu número de reservación o apellido.</p>
                <form>
                  <div className="form-group mb-3">
                    <input
                      type="text"
                      name="reservation_id"
                      value={formData?.reservation_id}
                      onChange={handleChange}
                      autoComplete="off"
                      required
                    />
                    <label htmlFor="name">
                    No. de reservación o apellido<span>*</span>
                    </label>
                    {errors.reservation_id && (
                      <p className="error-message">{errors.reservation_id}</p>
                    )}
                  </div>
                  
                  <div className="button_group">
                    <button  onClick={handleClick} className={"btn confirmBtn " + (isFormFilled() ? 'filled-button' : '')}>
                      Confirmar
                    </button>
                    <a onClick={() => goSplashScreen()} className="btn cancelBtn">
                      Cancelar
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
